<!-- @format -->
<bank-form-tag>

    <table class="detail_table">
        <tr class="detail_table-row">
            <th class="information_table-heading">
                銀行・支店情報
            </th>
            <td class="information_table-data">

                <div class="box_flex02">

                    <div class="box_w40">
                        <label class="form-heading" for="bank_name">銀行名</label>
                        <span class="text" id="bank_name">
                            {bankAccount.item.bank_name}
                        </span>

                        <input type="hidden" name="bank_code">
                    </div>
                </div>
                <div class="box_flex05 margin-spacing-3_top">
                    <div class="box_w40 margin-spacing-2_right">
                        <label class="form-heading" for="branch_name">支店名</label>
                        <span class="text" id="branch_name">
                            {bankAccount.item.branch_name}
                        </span>
                        <input type="hidden" name="branch_code">
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">預金種別</th>
            <td class="information_table-data">
                <div class="box_flex01">
                    <div class="box_w40">
                        <span class="text">普通</span>
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">口座番号</th>
            <td class="information_table-data">
                <div class="box_w40">
                    <span class="text">{bankAccount.item.branch_name}</span>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">口座名義<br>（カタカナ）</th>
            <td class="information_table-data">
                <div class="box_w40">
                    <span class="text">{bankAccount.item.account_name}</span>
                </div>
            </td>
        </tr>
    </table>

    <script>
        import di from "dependeny-injection";
        import bankAccount from "@model/bankAccount/api";
        import searchBankModal from "@tags/modal/info/search-bank-modal.riot";
        import bindingTag from "@tags/parts/info/bank-account/binding.riot";

        export default {
            components: {
                'binding-tag': bindingTag,
                'search-bank-modal-tag': searchBankModal,
            },
            bankAccount: bankAccount,
            searchModalIsOpen: false,
            onChangeType(e) {
                if (e.target.checked) {
                    this.bankAccount.item.account_type = e.target.value;
                }
            },
            closeSearchModal(e, bank, branch) {
                this.searchModalIsOpen = false
                if (bank && branch) {
                    this.bankAccount.item.bank_name = bank.bank_name_kanji;
                    this.bankAccount.item.bank_code = bank.bank_code;
                    this.bankAccount.item.branch_name = branch.branch_name_kanji;
                    this.bankAccount.item.branch_code = branch.branch_code;
                }
                this.update();
            },
            openSearchModal(e) {
                this.searchModalIsOpen = true
                this.update()
            },
            onBeforeMount() {
                this.api = di.createApi('info');
                this.bankAccount.trigger('fetch')
            },
            submit(e) {
                e.preventDefault()
                this.bankAccount.trigger('save')
            },
        }
    </script>
</bank-form-tag>